import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { Mode } from '../../../constants/enums';
import { getContrastTextColor } from '../../../utils/theme';

const useStyles = makeStyles((theme: Theme) => ({
  themeSwitch: {
    backgroundColor:
      theme.palette.mode === Mode.Dark
        ? theme.palette.background.default
        : theme.palette.primary.main,
    borderRadius: '4px',
    '& button': {
      border: '0 !important',
      borderRadius: '4px !important',
      padding: '0 !important',
      height: '30px',
      width: '30px',
    },
    '& .Mui-selected': {
      backgroundColor:
        theme.palette.mode === Mode.Dark
          ? '#fff !important'
          : `${theme.palette.secondary.contrastText} !important`,

      '& path': {
        stroke:
          theme.palette.mode === Mode.Dark
            ? '#000 !important'
            : `${getContrastTextColor(theme.palette.secondary.contrastText)} !important`,
      },
    },
  },
  uiSwitch: {
    '& span.MuiSwitch-track': {
      backgroundColor: `${theme.palette.mode === Mode.Dark
        ? theme.palette.common.white
        : theme.palette.secondary.contrastText} !important`,
    },
    '& .MuiSwitch-switchBase': {
      color: `${theme.palette.mode === Mode.Dark
        ? theme.palette.common.white
        : theme.palette.secondary.contrastText} !important`,
    },
  },
}));

export default useStyles;
